<div class="po-detail">
  <button mat-stroked-button type="button" (click)="back()">
    <mat-icon>arrow_back</mat-icon>
    Back
  </button>

  <div *ngIf="loading" class="state">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="!loading && po" class="document">
    <div class="doc-header">
      <div>
        <p class="eyebrow">{{ po.source === 'bidding' ? 'Bidding purchase order' : 'Purchase order' }}</p>
        <h1>{{ po.po_ref || ('PO #' + po.id) }}</h1>
        <p>{{ po.project_name }} <span *ngIf="po.boq_code">· {{ po.boq_code }}</span></p>
      </div>
      <div class="status">{{ po.po_status || 'draft' }}</div>
    </div>

    <div class="actions" *ngIf="canIssue() || canCancel() || canAmend() || canAccept() || canReject() || canCreateInvoice()">
      <button mat-raised-button color="primary" type="button" *ngIf="canIssue()" [disabled]="busy" (click)="issue()">Issue</button>
      <button mat-stroked-button color="warn" type="button" *ngIf="canCancel()" [disabled]="busy" (click)="cancel()">Cancel</button>
      <button mat-stroked-button type="button" *ngIf="canAmend()" [disabled]="busy" (click)="amend()">Amend</button>
      <button mat-raised-button color="primary" type="button" *ngIf="canAccept()" [disabled]="busy" (click)="accept()">Accept</button>
      <button mat-stroked-button color="warn" type="button" *ngIf="canReject()" [disabled]="busy" (click)="reject()">Reject</button>
      <button mat-raised-button color="accent" type="button" *ngIf="canCreateInvoice()" (click)="createInvoice()">Create invoice</button>
    </div>

    <div class="meta-grid">
      <div>
        <label>Issued by</label>
        <div>{{ po.issuer_org_name || '—' }}</div>
      </div>
      <div>
        <label>Vendor</label>
        <div>{{ po.vendor_org_name || po.vendor_name || '—' }}</div>
      </div>
      <div>
        <label>PO date</label>
        <div>{{ po.po_date | date:'mediumDate' }}</div>
      </div>
      <div>
        <label>Total</label>
        <div>{{ formatCurrency(po.total_value) }}</div>
      </div>
    </div>

    <table *ngIf="po.items?.length">
      <thead>
        <tr>
          <th>Item</th>
          <th>Unit</th>
          <th>Qty</th>
          <th>Rate</th>
          <th>Amount</th>
          <th>Rank</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of po.items">
          <td>
            <div class="code">{{ item.item_code || ('#' + item.item_id) }}</div>
            <div class="desc">{{ item.item_description }}</div>
          </td>
          <td>{{ item.unit || '—' }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ formatCurrency(item.unit_rate) }}</td>
          <td>{{ formatCurrency(item.amount) }}</td>
          <td>{{ item.assigned_rank || '—' }}</td>
        </tr>
      </tbody>
    </table>

    <p *ngIf="!po.items?.length" class="empty">
      {{ po.item_description || 'No line items on this purchase order.' }}
    </p>

    <section class="related" *ngIf="po.amendments?.length">
      <h2>Amendments</h2>
      <ul>
        <li *ngFor="let amendment of po.amendments">
          <strong>{{ amendment.amendment_type || 'Amendment' }}</strong>
          · {{ amendment.reason }}
          <span *ngIf="amendment.revised_total_value"> · {{ amendment.revised_total_value }}</span>
        </li>
      </ul>
    </section>

    <section class="related">
      <h2>Linked invoices</h2>
      <p *ngIf="!po.invoices?.length" class="empty">No invoices linked to this purchase order yet.</p>
      <ul *ngIf="po.invoices?.length">
        <li *ngFor="let invoice of po.invoices">
          <button type="button" class="linkish" (click)="viewInvoice(invoice)">
            {{ invoice.invoice_no || ('Invoice #' + invoice.id) }}
          </button>
          · {{ formatCurrency(invoice.total) }}
        </li>
      </ul>
    </section>
  </div>
</div>
